import {useLocalSearchParams} from "expo-router";
import {VideoDetailPage} from "@/components/media/video-detail/VideoDetailPage";
import {VideoSource} from "@/components/media/VideoSource";

export default function VideoDetailIndex() {
    const params = useLocalSearchParams<{
        orgId: string;
        videoId: string;
        source?: VideoSource;
        folderId?: string; // Only relevant when source is 'folder'
    }>();

    const props = {source: 'folder' as VideoSource, ...params};

    return VideoDetailPage(props);
}
